/* R44 PERFORMANCE — HOMEPAGE SECTIONS (r44-home-*)
   Auto-scrolling product carousel + category row arrows. Search lives in r44-product-search.js. */
(function () {
  if (window.__r44h) return;
  window.__r44h = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Auto-scrolling carousel (pauses on hover / touch / focus) ---------- */
  var marquees = [];
  function initMarquee(el) {
    if (el.__r44h) return; el.__r44h = true;
    var track = el.querySelector('.r44h-marquee__track');
    if (!track || !track.children.length) return;
    Array.prototype.slice.call(track.children).forEach(function (node) {
      var c = node.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      c.querySelectorAll('a,button').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(c);
    });
    var m = { el: el, paused: false, visible: true, acc: 0 };
    var pause = function () { m.paused = true; }, play = function () { m.paused = false; };
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', play);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', function () { setTimeout(play, 1500); }, { passive: true });
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', play);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { m.visible = en[0].isIntersecting; }).observe(el);
    marquees.push(m);
  }
  var last = 0;
  function tick(now) {
    var dt = last ? Math.min(now - last, 100) : 16; last = now;
    for (var i = 0; i < marquees.length; i++) {
      var m = marquees[i], el = m.el;
      if (m.paused || !m.visible || !el.isConnected) continue;
      m.acc += dt * 0.035;
      var n = Math.floor(m.acc); m.acc -= n;
      if (n) el.scrollLeft += n;
      var half = el.scrollWidth / 2;
      if (half && el.scrollLeft >= half) el.scrollLeft -= half;
    }
    requestAnimationFrame(tick);
  }

  /* ---------- Category row: arrows + hint only when the row overflows ---------- */
  function initScroller(root) {
    if (root.__r44h) return; root.__r44h = true;
    var row = root.querySelector('[data-r44h-scroll]');
    if (!row) return;
    var arrows = root.querySelectorAll('.r44h-arrow');
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      root.classList.toggle('is-scrollable', max > 4);
      if (arrows[0]) arrows[0].disabled = row.scrollLeft <= 4;
      if (arrows[1]) arrows[1].disabled = row.scrollLeft >= max - 4;
    }
    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        row.scrollBy({ left: Number(b.getAttribute('data-dir')) * row.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    row.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', update); });
    update();
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-r44h-marquee]').forEach(function (el) { if (!reduceMotion) initMarquee(el); });
    scope.querySelectorAll('[data-r44h-scroller]').forEach(initScroller);
  }

  function start() { initAll(document); requestAnimationFrame(tick); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
